import { fromJS } from 'immutable';

import {
  CHANGE_USER_LIST_VIEW,
  CONNECT_COMPANY_DRIVE_RESULT,
  TOGGLE_DEPARTAMENT_VIEW,
  TOGGLE_DISMISS_PROFILE_FORM,
  TOGGLE_USER_VIEW,
} from 'constants/ActionTypes';

const initialState = fromJS({
  viewType: 'cards',
  view: {
    isVisible: false,
    userId: null,
  },
  department: {
    isVisible: false,
    departmentId: null,
  },
  companyDrive: {
    status: null,
    data: null,
  },
});

const usersPageReducer = (state = initialState, action) => {
  switch (action.type) {
    case TOGGLE_DISMISS_PROFILE_FORM:
      if (state.getIn(['view', 'isVisible'])) {
        return state.setIn(['view', 'isVisible'], false);
      } else if (state.getIn(['view', 'userId'])) {
        return state.setIn(['view', 'isVisible'], true);
      }

      return state;
    case TOGGLE_USER_VIEW:
      return state.set(
        'view',
        fromJS({
          isVisible: !state.getIn(['view', 'isVisible']),
          userId: action.userId,
        }),
      );
    case CHANGE_USER_LIST_VIEW:
      return state.setIn(['viewType'], action.view);
    case TOGGLE_DEPARTAMENT_VIEW:
      return state.set(
        'department',
        fromJS({
          isVisible: !state.getIn(['department', 'isVisible']),
          departmentId: action.departmentId,
        }),
      );
    case CONNECT_COMPANY_DRIVE_RESULT:
      return state.set('companyDrive', fromJS(action.payload));
    default:
      return state;
  }
};

export default usersPageReducer;
